import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-shared-react/pkg/biLogger';
import { useFlag } from '@wix/da-shared-react/pkg/redux/flags/hooks';
import BrowseThumbLayout from '../../../BrowseThumbLayout';
import ContentLoader from '../../../ContentLoader';
import Strips from '../../../Strips';
import FeedLayout from '../../../FeedLayout';

export interface Props {
  initialOffset?: number;
  feedType?: string;
}

const DefaultPageContent: React.FC<Props> = ({ initialOffset, feedType }) => {
  const { t } = useTranslation();
  const top_strips_on_browse = useFlag('top_strips_on_browse');
  const isPostFeed = feedType === 'posts';

  return (
    <BiLoggerContextProvider
      value={{
        sectionname: 'general',
        _rankOffset: initialOffset,
      }}
    >
      {top_strips_on_browse && <Strips areTopStrips />}
      {isPostFeed && (
        <FeedLayout>
          <ContentLoader>
            <BrowseThumbLayout duperbrowseTitle={t('common.posts')} />
          </ContentLoader>
        </FeedLayout>
      )}
      {!isPostFeed && (
        <ContentLoader>
          <BrowseThumbLayout />
        </ContentLoader>
      )}
    </BiLoggerContextProvider>
  );
};
DefaultPageContent.displayName = 'DefaultPageContent';

export default DefaultPageContent;
